import React, { useState } from 'react';

const VoucherEntry = ({ onSuccess }) => {
    const [voucherCode, setVoucherCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isValid, setIsValid] = useState(false);
    const [email, setEmail] = useState('');

    const handleValidate = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = await fetch('/wp-json/rll/v1/booking/validate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ voucher_code: voucherCode }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Validation failed');
            setIsValid(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSendOTP = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = await fetch('/wp-json/rll/v1/booking/send-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ voucher_code: voucherCode, email }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Failed to send OTP');
            onSuccess({ code: voucherCode }, email);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="rll-animate-in" style={{ maxWidth: 420, margin: '0 auto' }}>
            {!isValid ? (
                <form onSubmit={handleValidate}>
                    <div className="rll-form-group">
                        <label htmlFor="rll_voucher_code">Experience Voucher Code</label>
                        <input
                            type="text"
                            id="rll_voucher_code"
                            className="rll-input rll-input--voucher"
                            placeholder="RLL-XXXX-XXXX"
                            value={voucherCode}
                            onChange={(e) => setVoucherCode(e.target.value.toUpperCase())}
                            required
                            disabled={loading}
                        />
                        <p className="rll-form-hint">Enter the code printed on your physical voucher.</p>
                    </div>

                    {error && <div className="rll-alert rll-alert--error">{error}</div>}

                    <button type="submit" disabled={loading} className="rll-btn rll-btn--primary">
                        {loading && <span className="rll-spinner" style={{ width: 18, height: 18, borderWidth: 2, marginBottom: 0 }} />}
                        {loading ? 'Validating...' : 'Validate Voucher'}
                    </button>
                </form>
            ) : (
                <form onSubmit={handleSendOTP} className="rll-animate-in">
                    <div className="rll-alert rll-alert--success">
                        ✓ Voucher Valid! Please verify your email to continue.
                    </div>

                    <div className="rll-form-group">
                        <label htmlFor="rll_email">Email Address</label>
                        <input
                            type="email"
                            id="rll_email"
                            className="rll-input rll-input--email"
                            placeholder="you@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={loading}
                        />
                        <p className="rll-form-hint">We'll send a secure 6-digit PIN to authenticate your booking.</p>
                    </div>

                    {error && <div className="rll-alert rll-alert--error">{error}</div>}

                    <button type="submit" disabled={loading} className="rll-btn rll-btn--primary">
                        {loading ? 'Sending PIN...' : 'Send Security PIN'}
                    </button>

                    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                        <button type="button" onClick={() => setIsValid(false)} className="rll-btn rll-btn--link">
                            Use a different voucher code
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default VoucherEntry;
